import Vue from 'vue'
import App from './App.vue'
import { PlakaLibrary, PlakaStore, PlakaRouter } from '@/plugin'

Vue.use(PlakaLibrary)

window.VuePLK = new Vue({
  router: PlakaRouter,
  store: PlakaStore.Store,
  render: h => h(App)
}).$mount('#app')
